'use client';

import { fromJS } from 'immutable';
import clsx from 'clsx';
import { useContext } from 'react';

import { trackClick } from '@/lib/event_tracker';
import navigateToCustomerPortal from '@/lib/navigateToCustomerPortal';
import { StateContext } from '@/lib/StateProvider';

import * as User from '@/lib/data/user';

import SupportEmailLink from '@/components/SupportEmailLink';
import SupportTwitterLink from '@/components/SupportTwitterLink';

export default function CurrentSubscriptionExplainer({
  sessionData,
  className,
}) {
  const session = fromJS(sessionData);
  const currentUser = session.get('user');
  const { dispatch } = useContext(StateContext);

  if (!currentUser || currentUser.isEmpty()) {
    return null;
  }

  return (
    <div
      className={clsx(
        'mx-auto w-full rounded-lg border border-gray-200 p-4 text-gray-600 shadow-md lg:w-96',
        className
      )}
    >
      {(() => {
        if (
          User.isFreePlanSubscriber(currentUser) &&
          !User.isPaidPlanSubscriber(currentUser)
        ) {
          return (
            <div className="flex flex-col space-y-4">
              <h4 className="text-lg font-semibold">
                Hi, {User.firstName(currentUser)}!
              </h4>

              <p>
                With a free account you can see and ♥ like the stories others
                are creating.
              </p>

              <p>
                When you&apos;re ready to start creating your own stories choose
                below the plan that fits you best!
              </p>

              <p>
                If you have any questions or suggestions don&apos;t hesitate to
                send me an email at{' '}
                <SupportEmailLink sessionOrSessionData={session} /> or reach out
                on Twitter at{' '}
                <SupportTwitterLink sessionOrSessionData={session} />.
              </p>
            </div>
          );
        } else if (User.isPaidPlanSubscriber(currentUser)) {
          const planTier = User.subscriptionPlanTier(currentUser);

          return (
            <div className="flex flex-col space-y-4">
              <h4 className="text-lg font-semibold">
                Hi, {User.firstName(currentUser)}!
              </h4>

              <p>
                You&lsquo;re currently subscribed to the &lsquo;
                <span className="font-semibold">{planTier.productName}</span>
                &rsquo; plan at{' '}
                <span className="font-semibold">
                  ${planTier.priceInCents / 100}/{planTier.billingIntervalUnit}
                </span>
                .
              </p>

              <p>
                If you&lsquo;d like to update your subscription you can click
                the button below:
              </p>

              <button
                type="button"
                className="mb-2 mr-2 rounded-lg border border-gray-300 bg-white px-5 py-2.5 font-medium text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:hover:border-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
                onClick={(_e) => {
                  navigateToCustomerPortal(dispatch, session, null);

                  trackClick(session, null, 'Manage Subscription Button');
                }}
              >
                Manage subscription
              </button>

              <p>
                If you have any questions or suggestions don&apos;t hesitate to
                send me an email at{' '}
                <SupportEmailLink sessionOrSessionData={session} /> or reach out
                on Twitter at{' '}
                <SupportTwitterLink sessionOrSessionData={session} />.
              </p>
            </div>
          );
        }

        return null;
      })()}
    </div>
  );
}
